















































































































































































































































































































































































































import { defineComponent, ref } from '@nuxtjs/composition-api';
import { appStore } from '@/store';
import { Search } from '@/compositions/base-search';
import { useStore } from '@/compositions/store';
import checkUser from '@/utils/check-user';
import TopFeatureCards from '@/components/top-feature-cards.vue';

import '@/assets/css/reset.css';
import '@/assets/css/index-index.css';
import '@/assets/css/index-index_sp.css';
import '@/assets/css/global_top.css';

export default defineComponent({
  components: {
    TopFeatureCards
  },
  layout: 'plain',
  middleware: [checkUser],
  setup() {
    const { loadData, items, loaded, loadDataWoState } = Search();

    const { setOverlay } = useStore();

    const css = ref('');

    setOverlay(true);

    // CSSデータ取得API実行
    const getCss = async (): Promise<any> => {
      const data = await loadDataWoState(
        `${self.$nuxt.context.$config.assetUrl}/customize/${appStore.systemPrefix}/global_top.css`,
        {},
        'get',
        false,
        true
      );
      if (data) {
        css.value = data;
      }
    };
    getCss();

    // データ取得API実行
    loadData({
      url: '/api/v1/news/search',
      conditions: { rows: 3, page: 1 }
    }).then(() => {
      setOverlay(false);
    });

    return { appStore, items, loaded, css };
  }
});
